import { DegreeTypeText } from '../../../keyword-helper/enums/DegreeTypeText';
import { KeywordHelperType } from '../../../keyword-helper/enums/KeywordHelperType';
import { KeywordHelperContent } from '../../../keyword-helper/KeywordHelperContent';

class MoreSpecificPhdDefinition extends KeywordHelperContent {
	public constructor() {
		super(KeywordHelperType.BE_MORE_SPECIFIC, DegreeTypeText.PHD);
	}
}

export default new MoreSpecificPhdDefinition();
